import React, { Suspense, lazy } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Sidebar, Segment } from 'semantic-ui-react';
import { route } from 'src/app/route';
import { HeaderBar } from 'src/components/header-bar';
import { parseNumber } from 'src/utils';
import MenuBar from './menu-bar';
const BuyAgriProductHistory = lazy(() => import('src/components/buy-agri-product/buy-agri-product-history'));

interface IDeliveryHistoryParams {
  customerId?: string;
}

export class BuyAgriProductHistoryPage extends React.PureComponent<RouteComponentProps<IDeliveryHistoryParams>> {
  public componentDidMount() {
    document.title = route.getPageTitle(this.props.location.pathname);
  }

  public render() {
    const title = route.getPageTitle(this.props.location.pathname);
    const customerId = parseNumber(this.props.match.params.customerId);
    return (
      <Sidebar.Pushable as={Segment} className='x-page'>
        <MenuBar />

        <Sidebar.Pusher>
          <Segment basic={true}>
            <HeaderBar title={title} />
            <Suspense fallback={<div className='x-loading' />}>
              <BuyAgriProductHistory customerId={customerId}/>
            </Suspense>
          </Segment>
        </Sidebar.Pusher>
      </Sidebar.Pushable>
    );
  }
}
